<template>
    <span class="union-star" @click="handle">
        <img src="../assets/images/star_on.png" v-if="isActive">
        <img src="../assets/images/star_off.png" v-else>
    </span>
</template>
<script>
    export default {
        props: {
            isActive: { //是否激活
                type: Boolean,
                default: false
            }
        },
        methods:{
            handle(){
                this.$emit("handle");
            }
        }
    }
</script>
<style>
    .union-star{
        width: 0.38rem;
        overflow: hidden;
        margin: 0;
        float: left;
    }
</style>



// WEBPACK FOOTER //
// src/shared/components/star.vue